import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import { format } from "date-fns";

export const ProgramaApadrinhamento = ({ data, idCrianca }) => {
  const columns = [
    {
      Header: "Nome",
      accessor: "nomePessoaApadrinhamento",
      Cell: (props) => {
        const nomePessoaApadrinhamento = props?.value;

        return (
          <span>
            {nomePessoaApadrinhamento ? nomePessoaApadrinhamento : ""}
          </span>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "tipoPessoaProgApadrinha",
      Cell: (props) => {
        const tipo = props?.value;

        return (
          <span>
            {tipo === "P"
              ? "Padrinho (Programa)"
              : tipo === "M"
                ? "Madrinha (Programa)"
                : ""}
          </span>
        );
      },
    },
    {
      Header: "Data Início",
      accessor: "dataInicioApadrinhamento",
      Cell: (props) => {
        const dataInicioApadrinhamento = props?.value;

        return (
          <span>
            {dataInicioApadrinhamento
              ? format(new Date(dataInicioApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
    {
      Header: "Data Fim",
      accessor: "dataFimApadrinhamento",
      Cell: (props) => {
        const dataFimApadrinhamento = props?.value;

        return (
          <span>
            {dataFimApadrinhamento
              ? format(new Date(dataFimApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
    {
      Header: "Informações Complementares",
      accessor: "informacaoComplementar",
      Cell: (props) => {
        const informacaoComplementar = props?.value;

        return (
          <span>{informacaoComplementar ? informacaoComplementar : ""}</span>
        );
      },
    },
  ];

  return data ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Programa de Apadrinhamento"
          py="12px"
          mtDivider="5px"
        >
          <Flex mt="17px" direction={"column"} gap="18px">
            <Box>
              <Text as="b">
                Está incluído (a) no Programa de Apadrinhamento?{" "}
              </Text>
              <Text>
                {data.incluidoProgApadrinh === "S"
                  ? "Sim"
                  : data.incluidoProgApadrinh === "N"
                    ? "Não"
                    : "Sem Informação"}
              </Text>
            </Box>

            {data.incluidoProgApadrinh === "S" && (
              <Box>
                <Text as="b">Está Sendo Apadrinhado? </Text>
                <Text>
                  {data.sendoApadrinhado === "S"
                    ? "Sim"
                    : data.sendoApadrinhado === "N"
                      ? "Não"
                      : "Sem Informação"}
                </Text>
              </Box>
            )}

            {data.sendoApadrinhado === "S" ? (
              <>
                {data.pessoasProgramaApadrinhamento &&
                  data.pessoasProgramaApadrinhamento.length > 0 && (
                    <IrmaoTable
                      mt={"0px"}
                      columns={columns}
                      data={data.pessoasProgramaApadrinhamento}
                      filiacoes={data}
                      idCrianca={idCrianca}
                      entidade="apadrinhamento"
                      disableHeaderOptions={true}
                      disableHeaderOptionsPagination={true}
                      isPrint={true}
                    />
                  )}
              </>
            ) : (
              ""
            )}
          </Flex>
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Programa de Apadrinhamento"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
